import { render, staticRenderFns } from "./AddPanelToDashboard.vue?vue&type=template&id=78360540"
import script from "./AddPanelToDashboard.vue?vue&type=script&lang=js"
export * from "./AddPanelToDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports